import React from 'react';
import PropTypes from 'prop-types';
import * as S from './DatePicker.styles';
import { CalendarIcon, ArrowDownIcon } from '@edusynch/edusynch-svg-icons';

export const DatePicker = ({ placeholder, noArrow, CustomIcon, ...props }) => {
  const inputRef = React.useRef(null);
  const [isFocused, setIsFocused] = React.useState(false);
  const [isFilled, setIsFilled] = React.useState(false);

  const handleInputBlur = React.useCallback(() => {
    setIsFocused(false);

    setIsFilled(!!inputRef.current?.value);
  }, []);

  return (
    <S.Container>
      <CalendarIcon />
      <S.DatePicker
        ref={inputRef}
        type={isFocused || isFilled ? 'date' : 'text'}
        placeholder={placeholder}
        isFocused={isFocused}
        isFilled={isFilled}
        onFocus={() => setIsFocused(true)}
        onBlur={handleInputBlur}
        onMouseEnter={() => setIsFocused(true)}
        onMouseLeave={handleInputBlur}
        {...props}
      />
      {(!noArrow && <CustomIcon />) || <ArrowDownIcon />}
    </S.Container>
  );
};

DatePicker.propTypes = {
  placeholder: PropTypes.string,
  CustomIcon: PropTypes.func,
  noArrow: PropTypes.bool,
};
